import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./ui.module.css";

type Variant = "primary" | "secondary" | "danger" | "ghost";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  children: ReactNode;
};

export function buttonVariantClass(variant: Variant): string {
  const map: Record<Variant, string | undefined> = {
    primary: styles.primary,
    secondary: styles.secondary,
    danger: styles.danger,
    ghost: styles.ghost,
  };
  return map[variant] ?? "";
}

/** Shared button owner — onClick is destructured and forwarded explicitly for auditability. */
export function Button({
  variant = "primary",
  className,
  children,
  type = "button",
  onClick,
  ...rest
}: Props) {
  return (
    <button
      type={type}
      className={[styles.btn, buttonVariantClass(variant), className].filter(Boolean).join(" ")}
      {...rest}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
